module.exports = __webpack_public_path__ + "static/img/11.143cb0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/11.png
// module id = Kr2S
// module chunks = 0